import { InjectionToken } from '@angular/core';

import { UserModuleConfiguration } from './models/configuration';

export const UserConfigurationService = new InjectionToken<UserModuleConfiguration>('UserModuleConfiguration');
